const state = () => ({
  currentJobRequest: {},
  currentJobRequestProject: {}
});

const getters = {
  currentJobRequest: (state) => state.currentJobRequest,
  currentJobRequestProject: (state) => state.currentJobRequestProject
};

const mutations = {
  SET_CURRENT_JOB_REQUEST(state, value) {
    state.currentJobRequest = value;
  },
  SET_CURRENT_JOB_REQUEST_PROJECT(state, value) {
    state.currentJobRequestProject = value;
  }
};

const actions = {
  setCurrentJobRequest({ commit }, value) {
    commit('SET_CURRENT_JOB_REQUEST', value);
  },
  setCurrentJobRequestProject({ commit }, value) {
    commit('SET_CURRENT_JOB_REQUEST_PROJECT', value);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
